import { Button, Card, Col, Drawer, Form, notification } from 'antd'
import TextArea from 'antd/lib/input/TextArea'
import React from 'react'

@Form.create()
class AddAbstractAffiliate extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      affiliate: ''
    }
  }

  submitForm = () => {
    if (!this.state.affiliate) {
      notification.warning({
        message: 'Enter affiliate'
      })
      return
    }

    this.props.addAffiliateData(this.state)
    this.setState({
      affiliate: ''
    })
    this.props.onClose()
  }

  render() {
    let { visible, onClose } = this.props

    return (
      <Drawer
        title={'Add Affiliation'}
        width={'60%'}
        visible={visible}
        maskClosable={true}
        placement="right"
        onClose={onClose}>
        <Card>
          <Form hideRequiredMark className={'inputForm'}>
            <Col span={24} className="flexColumn">
              <Form.Item label="Affiliate" name="affiliate" required>
                <TextArea
                  value={this.state.affiliate}
                  placeholder="Enter affiliate..."
                  onChange={e => {
                    this.setState({
                      affiliate: e.target.value
                    })
                  }}
                />
              </Form.Item>
            </Col>

            <Col span={6}>
              <Form.Item>
                <Button
                  type="primary"
                  onClick={() => {
                    this.submitForm()
                  }}>
                  Submit
                </Button>
              </Form.Item>
            </Col>
          </Form>
        </Card>
      </Drawer>
    )
  }
}

export default AddAbstractAffiliate